import { HttpClient } from '@angular/common/http';
import { APP_INITIALIZER, Inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { serviceConstants } from '../constants/service.constants';


@Injectable({
  providedIn: 'root'
})
export class AppPreSetupService {
 InitBaseUrl:string="";
  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    if(baseUrl!=null && baseUrl.indexOf("localhost")>-1)
    {
        this.InitBaseUrl=serviceConstants.apiURL;

    }
    else{
        this.InitBaseUrl=baseUrl;

    }
   }

  load() {
    return new Promise((resolve, reject) => {
       this._http.get(this.InitBaseUrl+'api/Login/GetConfigData').subscribe(
        (response:any) => {
            serviceConstants.apiURL=response.Data.apiURL;
            serviceConstants.baseUrl=response.Data.baseUrl;
            serviceConstants.AdobeViewerClientID=response.Data.AdobeViewerClientID;
          resolve(true);
        },
        (error) => {
          console.error(error);
          throw (error.json().error || 'Server error')
          //return Observable.throw(error.json().error || 'Server error');
        });
    });
  }

}
export function AppPreSetupFactory(preService: AppPreSetupService) {
  return () => preService.load();
}

export function init() {
  return {
    provide: APP_INITIALIZER,
    useFactory: AppPreSetupFactory,
    deps: [AppPreSetupService],
    multi: true
  }
}

const AppPreSetupModule = {
  init: init
}

export { AppPreSetupModule };
